import {
  EDIT,
  CLEAR_EDIT,
  EDIT_TITLE,
  EDIT_TYPE,
  EDIT_AUDIO,
  EDIT_VOICE,
  EDIT_PICTURE,
  EDIT_VOICE_TYPE,
  EDIT_LANGUAGE,
  EDIT_REVIEWED_WORDS,
  EDIT_REVIEWED_INDIRECTLY,
  EDIT_WORDS,
  EDIT_ANSWER,
  EDIT_WORD,
  EDIT_OPTION,
  EDIT_CORRECT_ANSWER,
  EDIT_ID,
  EDIT_NEW_WORDS,
} from "./types";

export const setEdit = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT, payload });
  };
};
export const setClearEdit = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: CLEAR_EDIT, payload });
  };
};
export const setEditTitle = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_TITLE, payload });
  };
};
export const setEditType = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_TYPE, payload });
  };
};
export const setEditAudio = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_AUDIO, payload });
  };
};
export const setEditVoice = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_VOICE, payload });
  };
};
export const setEditPicture = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_PICTURE, payload });
  };
};
export const setEditVoiceType = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_VOICE_TYPE, payload });
  };
};
export const setEditLanguage = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_LANGUAGE, payload });
  };
};
export const setEditReviewedWords = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_REVIEWED_WORDS, payload });
  };
};
export const setEditReviewedIndirectly = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_REVIEWED_INDIRECTLY, payload });
  };
};
export const setEditWords = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_WORDS, payload });
  };
};
export const setEditAnswer = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_ANSWER, payload });
  };
};
export const setEditWord = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_WORD, payload });
  };
};
export const setEditOption = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_OPTION, payload });
  };
};
export const setEditCorrectAnswer = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_CORRECT_ANSWER, payload });
  };
};
export const setEditId = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_ID, payload });
  };
};
export const setEditNewWords = (payload) => {
  return async (dispatch) => {
    await dispatch({ type: EDIT_NEW_WORDS, payload });
  };
};
